import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import ScheduleForm from "@/components/forms/ScheduleForm";

export default function Schedule() {
  return (
    <>
      <SEO
        title="Schedule a Call With Michael | 1907 Insurance Group"
        description="Choose a day and time that works for you, and Michael Janas will call to discuss your life insurance options."
      />
      <PageHero
        eyebrow="Schedule a Call"
        title="Choose a Time That Works for You"
        intro="Tell us the days and times you're usually available. Someone will be in contact soon to confirm a good time to talk."
      />
      <section className="py-14 md:py-20" data-testid="schedule-page-form">
        <div className="container-site max-w-2xl">
          <Reveal>
            <ScheduleForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
